import React from 'react';
import DatasetItemUI from '@/pages/Result/components/DatasetItemUI.tsx';
import DirectoryDatasetSidebarItem from '@/pages/Result/components/DirectoryDatasetSidebarItem.tsx';
import { Run } from '@/types/runs.ts';
import { Dataset } from '@/types/datasets.ts';

type props = {
  run: Run;
  dataset: Dataset;
  addTab: (datasetId: string) => void;
};

const DatasetSidebarItem = ({ run, dataset, addTab }: props) => {
  // const { showChat } = useViewChatSidebar();

  // const automationId = useAutomationId();

  // const url = showChat
  //   ? `/automations/${automationId}/results/${run.id}?datasetId=${dataset.id}&showChat=true`
  //   : `/automations/${automationId}/results/${run.id}?datasetId=${dataset.id}`;

  if (dataset.is_natual_directory) {
    return <DirectoryDatasetSidebarItem run={run} dataset={dataset} addTab={addTab} />;
  }

  return (
    // <Link to={url} replace={true} style={{ display: 'contents', textDecoration: 'none' }}>
    <DatasetItemUI dataset={dataset} addTab={addTab} />
    // </Link>
  );
};

export default DatasetSidebarItem;
